(function () {
  'use strict';

  angular
      .module('tfc.retailer.StandardReports')
      .factory('AreaLineChartAxisHandle', AreaLineChartAxisHandle);

  function AreaLineChartAxisHandle(ReportFormat, Filters, DateUtil, $translate) {

    return {
      getDetailLevel: getDetailLevel,
      getTicks: getTicks,
      getXAxisOptions: getXAxisOptions,
      getYAxisOptions: getYAxisOptions,
      prependXLabel: prependXLabel
    };

    function getDetailLevel(dateRange) {

      var diff = getDateDiff(dateRange);

      if(diff <= 92){
        return ReportFormat.Daily;
      } else {
        if(diff >= 93 && diff < 366){
          return ReportFormat.Weekly;
        } else if(diff >= 366){
          return ReportFormat.Monthly;
        }
      }
    }

    function getTicks(detailLevel, dateRange) {

      var diff = getDateDiff(dateRange);

      if(diff <= 15){
        if(detailLevel === ReportFormat.Daily) {
          return getDailyTicks();
        } else {
          if(detailLevel === ReportFormat.Weekly){
            return getWeekTicks();
          } else if(detailLevel === ReportFormat.Monthly){
            return getMonthTicks();
          }
        }
      } else {
        if(diff >= 16 && diff <= 31){
          if(detailLevel === ReportFormat.Daily) {
            return getDailyTicks(2);
          } else {
            if(detailLevel === ReportFormat.Weekly){
              return getWeekTicks();
            } else if(detailLevel === ReportFormat.Monthly){
              return getMonthTicks();
            }
          }
        } else {
          if(diff >= 32 && diff <= 92){
            if(detailLevel !== ReportFormat.Monthly) {
              return getWeekTicks();
            } else {
              return getMonthTicks();
            }
          } else {
            if(diff >= 93 && diff < 366){
              if(detailLevel === ReportFormat.Weekly){
                return getWeekTicks(4);
              } else {
                return getMonthTicks();
              }
            } else {
              if(diff >= 366){
                if(detailLevel !== ReportFormat.Weekly){
                  return getMonthTicks(monthInterval(diff));    // Interval of months
                } else {
                  return getWeekTicks(monthInterval(diff) * 4); // Interval for weeks divide month into 4 for per week
                }
              }
            }
          }
        }
      }

    }

    function monthInterval(diff){
     return Math.round((diff/(12 * 30)));
    }

    function getDailyTicks(tickInterval){
      return {ticks: d3.time.days, tickInterval: tickInterval || 1};
    }

    function getWeekTicks(tickInterval){
      return {ticks: d3.time.weeks, tickInterval: tickInterval || 1};
    }

    function getMonthTicks(tickInterval){
      return {ticks: d3.time.months, tickInterval: tickInterval || 1};
    }

    function getDateDiff(dateRange) {
      return moment(dateRange.endDate).diff(moment(dateRange.startDate), 'days');
    }

    function prependXLabel(detailLevel) {
      return function(d) {
        switch(detailLevel) {
          case ReportFormat.Weekly :
            return 'Week of ' + DateUtil.shortMonthDate(d);
          case ReportFormat.Monthly :
            return DateUtil.onlyMonth(d);
          default :
            return DateUtil.shortMonthDateWithDayOfWeek(d);
        }
      }
    }

    function getXAxisTickPositions(detailLevel, data){
      var dates = _.head(_.head(data)).dates;
      var xTicks = getTicks(detailLevel, Filters.getFilter().dateRange);

      var startDate = moment(_.first(dates));
      var endDate = moment(_.last(dates)).add(1, 'days'); //adding 1 day else would ignore the endDate

      var ticksForDetailLevel = _.map(xTicks.ticks(startDate, endDate, xTicks.tickInterval || 1),
          DateUtil.formatToYearMonthDay)

      return _.map(ticksForDetailLevel, function (tick) {
        return _.indexOf(dates, tick);
      });
    }

    function getXAxisOptions(data, detailLevel, multipleXAxis, xAxisFormatter) {
      var xAxesData = multipleXAxis ? data : _.take(data, 1);
      return _.map(xAxesData, function (range, index) {
        var xAxisOptions =  {
          labels: {
            formatter: xAxisFormatter,
            overflow: 'allow'
          },
          enabled: true,
          categories: _.head(range).dates,
          tickPositions: getXAxisTickPositions(detailLevel, xAxesData),
          crosshair: { zIndex: 3 },
          margin: 0,
          tickWidth: 1,
          tickmarkPlacement: 'on'
        };

        if(index > 0) {
          _.extend(xAxisOptions, {
            className: 'zero-width' //class name to hide the axis but not labels
          });
        }

        return xAxisOptions;
      })
    }

    function yAxisLabelFormatter() {
      var numericSymbols = this.chart.options.lang.numericSymbols,
          i = numericSymbols && numericSymbols.length,
          value = this.value;

      if (value >= 1000) {
        while (i--) {
          var multi = Math.pow(1000, i + 1);

          if(value % multi !== value) {
            value = Highcharts.numberFormat(value / multi, -1) + numericSymbols[i];
            break;
          }
        }
      }
      return value;
    }

    function getYAxisOptions(valueType, drawAreaChart, axisLabel, data) {

      return {
        title: {
          text: $translate.instant(axisLabel)
        },
        min: 0,
        tickAmount: 5,
        labels: {
          formatter: yAxisLabelFormatter
        },
        showFirstLabel: false
      }
    }

  }
})();